<template>
    <div>
        <el-row class="padding_50">
            <el-col
                :span="24"
                class="margin_20"
            >
                <div style="margin-bottom:20px;color:#aaa;">重置您的密码</div>
                <el-form :model="form" ref="form" :rules="rules">
                    <el-form-item prop="password">
                        <el-input
                            v-model="form.password"
                            type="password"
                            size="medium"
                            placeholder="新密码"
                        />
                    </el-form-item>
                    <el-form-item prop="twopassword">
                        <el-input
                            v-model="form.twopassword"
                            type="password"
                            size="medium"
                            placeholder="确认密码"
                        />
                    </el-form-item>
                </el-form>

            </el-col>

            <el-col
                :span="24"
                class="margin_20"
            >
                <el-button
                    type="primary"
                    :loading="is_post"
                    style="width:100%;margin-bottom: 20px"
                    @click="submit"
                >
                    确认
                </el-button>
            </el-col>
            <el-col
                :span="24"
                class="margin_20"
            >
                <el-button
                    style="width:100%;"
                    @click="goBack()"
                >
                    返回
                </el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import request from '@/utils/request'
import Cookies from 'js-cookie'

export default {
    name: 'auth_changePassword',
    data() {
        let validqrpwd = (rule, value, callback)=>{
            if(value){
                if(value != this.form.password){
                    callback(new Error("两次密码不同"));
                }else{
                    callback();
                }
            }else{
                callback(new Error("请填写确认密码"));
            }
        }
        return {
            ticket:"",
            form: {
                password: '',
                twopassword: ''
            },
            rules: {
                password:[
                    { required: true, message: '请填写新密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '密码长度在6-20位', trigger: 'blur' }
                ],
                twopassword:[
                    { required: true, message: '请填写确认密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '密码长度在6-20位', trigger: 'blur' },
                    { validator:validqrpwd, trigger: 'blur' }
                ]
            },
            is_post: false
        }
    },
    created() {
        let ticket = Cookies.get("forgetPwdTicket");
        if(ticket){
            this.ticket = ticket;
        }else{
            this.$message.warning("您没有修改密码凭证!");
            this.$router.back();
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1)
        },
        submit() {
            this.$refs["form"].validate(valid=>{
                if(!valid) return false;
                this.is_post = true
                request.post('forget_pwd_change', {uuid:this.ticket,password:this.form.password}).then(res => {
                    this.$message.success('重置密码成功,请使用新密码登录!')
                    this.$router.replace('/redirect/auth/login')
                    this.is_post = false
                }).catch(err => {
                    this.is_post = false
                });
            });
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/styles/element-variables.scss";

.padding_50 {
    padding: 20px 50px 20px 10px;
    @media (max-width: 767px) {
        padding: 0 0 0 0;
    }
}

.margin_20 {
    width: 100%;
    margin: 0px 20px 0 20px;
    padding: 0 30px;
    @media (max-width: 767px) {
        margin: 0;
        padding: 10px 0;
    }
}

.gray_text {
    color: #999;
}

.other_login_icon {
    margin-left: 16px;
    color: rgba(0, 0, 0, .2);
    font-size: 24px;
    vertical-align: middle;
    cursor: pointer;
    transition: color .3s;
    line-height: 0;
    text-align: center;

    &:hover {
        color: $--color-primary;
    }
}
</style>
